var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dashboardRole === "student"
    ? _c("StudentAdmission")
    : _vm.dashboardRole === "teacher"
    ? _c("TeacherDashboard")
    : _vm.dashboardRole === "admin"
    ? _c("AdminDashboard")
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }